import type { ParticipantId } from "../types/common";
import type { Participant, StoneFlickingCoreState } from "../types/game-state";

export function getActiveParticipantIds(
  participants: ReadonlyArray<Participant>,
  eliminatedParticipants: ReadonlyArray<ParticipantId>,
): ReadonlyArray<ParticipantId> {
  return participants
    .map((p) => p.id)
    .filter((id) => !eliminatedParticipants.includes(id));
}

export function countActiveParticipants(
  participants: ReadonlyArray<Participant>,
  eliminatedParticipants: ReadonlyArray<ParticipantId>,
): number {
  return getActiveParticipantIds(participants, eliminatedParticipants).length;
}

export function isAllInputsReceived(state: StoneFlickingCoreState): boolean {
  const activeIds = getActiveParticipantIds(
    state.participants,
    state.eliminatedParticipants,
  );
  return activeIds.every((id) => state.submittedParticipants.includes(id));
}

export function isParticipantKnown(
  participants: ReadonlyArray<Participant>,
  participantId: ParticipantId,
): boolean {
  return participants.some((p) => p.id === participantId);
}

export function isParticipantActive(
  participants: ReadonlyArray<Participant>,
  eliminatedParticipants: ReadonlyArray<ParticipantId>,
  participantId: ParticipantId,
): boolean {
  return (
    isParticipantKnown(participants, participantId) &&
    !eliminatedParticipants.includes(participantId)
  );
}
